import { render, staticRenderFns } from "./Equipment.vue?vue&type=template&id=1bdd4b15&"
import script from "./Equipment.vue?vue&type=script&lang=js&"
export * from "./Equipment.vue?vue&type=script&lang=js&"
import style0 from "./Equipment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VSelect})
